/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

function ModalConfirmacion({ open, onClose, onConfirm, titulo, mensaje }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ backgroundColor: "#1a2035" }}>{titulo || "Confirmar acción"}</DialogTitle>
      <DialogContent style={{ backgroundColor: "#1a2035" }}>
        <DialogContentText>
          {mensaje || "¿Estás seguro que deseas continuar?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ backgroundColor: "#1a2035" }}>
        <Button onClick={onClose} color="error">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" autoFocus>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalConfirmacion;
